import { FavoriteProduct } from '@/interfaces'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface State {
  favorites: FavoriteProduct[]

  addProductToFavorite: (product: FavoriteProduct) => void
  removeProductToFavorite: (productId: string) => void
}

export const useFavoritesStore = create<State>()(
  persist(
    (set, get) => ({
      favorites: [], // Estado inicial vacío

      // Métodos
      addProductToFavorite: (product: FavoriteProduct) => {
        const { favorites } = get()

        // Revisar si el producto ya ha sido agregado
        if (!favorites.some((item) => item.id === product.id)) {
          // Solo actualizar si el producto no está ya en favoritos
          set({ favorites: [...favorites, product] })
        }
      },

      removeProductToFavorite: (productId: string) => {
        const { favorites } = get()

        // Solo actualizamos si el producto existe
        if (favorites.some((item) => item.id === productId)) {
          const updatedFavoriteProducts = favorites.filter(
            (item) => item.id !== productId
          )
          set({ favorites: updatedFavoriteProducts })
        }
      }
    }),
    {
      name: 'favorites', // Nombre del almacenamiento
      storage: createJSONStorage(() => localStorage) // Utilizar localStorage explícitamente
    }
  )
)

// Establecer el estado después de la creación del store
useFavoritesStore.setState((state) => {
  const favoritesFromStorage = state.favorites || []

  if (favoritesFromStorage.length > 0) {
    return { favorites: favoritesFromStorage }
  }

  // Si no hay favoritos guardados, no necesitas devolver nada
  return {}
})
